import { buildPaths } from '@front/logic/others/buildPaths'

const WorkerRoutes = buildPaths({
  Worker: {
    Home: {},
    JobOffers: {
      Institution: {},
    },
    Schedule: {
      Details: {
        id: {
          param: true,
          Pool: {
            Apply: {},
          },
          Network: {
            Apply: {},
            Dealing: {},
          },
          Shift: {
            Cancel: {},
            Contact: {},
          },
          Applied: {},
        },
      },
      ShiftHistory: {},
    },
    Login: {
      ResetPassword: {
        GetCode: {},
        SendCode: {},
        NewPassword: {},
      },
    },
    Pool: {
      Specialties: {},
      Address: {},
      Notifications: {},
      Completed: {},
      Documents: {
        type: {
          param: true,
        },
      },
      Jobs: {},
      Radius: {},
      PersonalInformation: {},
      Welcome: {},
    },
    Profile: {
      Details: {
        ProfessionalSituation: {},
        DeleteMyAccount: {},
        AccountDeleted: {},
        Email: {},
        HomeAddress: {},
        Password: {},
        PersonalInformation: {},
        PhoneNumber: {},
        ProfilePicture: {},
      },
      Documents: {
        type: {
          param: true,
        },
      },
      Institutions: {
        idInstitution: {
          param: true,
          Presentation: {},
          RestrictedByPricingPlan: {},
        },
        Detail: {
          departments: {
            idInstitution: {
              param: true,
            },
          },
          idInstitution: {
            param: true,
          },
        },
        JoinOptions: {},
        Search: {},
        SearchByCode: {
          code: {
            param: true,
          },
        },
      },
      Jobs: {
        AddJob: {},
        AddSpecialties: {},
        JobDetails: {},
      },
      Availabilities: {
        Shift: {
          idMission: {
            param: true,
          },
        },
        Shifts: {
          date: {
            param: true,
          },
        },
        Add: {},
      },
      Notifications: {
        ByTemplate: {},
      },
      Community: {},
      Cgu: {},
      PrivacyPolicy: {},
      CancellationPolicy: {},
      Pool: {
        Cancellation: {
          CancellationTracking: {},
        },
        Presentation: {},
        VerifiedSpecialties: {},
        WhatsApp: {},
        WorkArea: {},
      },
      Feedback: {},
    },
    Shifts: {
      Details: {
        idMission: {
          param: true,
          Cancel: {},
          Contact: {},
          Applied: {},
        },
      },
    },
    Offers: {
      Details: {
        id: {
          param: true,
          Pool: {
            Apply: {},
          },
          Network: {
            Apply: {},
            Dealing: {},
          },
        },
      },
    },
    NetworkApplications: {
      idNetworkApplication: {
        param: true,
        WorkingInstitutions: {},
        EmploymentStatus: {},
        EmploymentStatusIncompatibleWithPricingPlan: {},
        Jobs: {},
        Specialties: {},
        Assignment: {},
        RegistrationNumber: {},
        Charter: {},
        PersonalInformation: {},
        Documents: {
          type: {
            param: true,
          },
        },
        Notifications: {},
        Summary: {},
        Completed: {},
        MissingDocuments: {},
      },
    },
  },
})

export const WorkerRoutesVariables = {
  Worker: WorkerRoutes.Worker.path,
  WorkerHome: WorkerRoutes.Worker.Home.path,
  WorkerLogin: WorkerRoutes.Worker.Login.path,
  WorkerLoginResetPasswordGetCode:
    WorkerRoutes.Worker.Login.ResetPassword.GetCode.path,
  WorkerLoginResetPasswordSendCode:
    WorkerRoutes.Worker.Login.ResetPassword.SendCode.path,
  WorkerLoginResetPasswordNewPassword:
    WorkerRoutes.Worker.Login.ResetPassword.NewPassword.path,
  WorkerPool: WorkerRoutes.Worker.Pool.path,
  WorkerPoolNotifications: WorkerRoutes.Worker.Pool.Notifications.path,
  WorkerPoolCompleted: WorkerRoutes.Worker.Pool.Completed.path,
  WorkerPoolWelcome: WorkerRoutes.Worker.Pool.Welcome.path,
  WorkerPoolJobs: WorkerRoutes.Worker.Pool.Jobs.path,
  WorkerPoolSpecialties: WorkerRoutes.Worker.Pool.Specialties.path,
  WorkerPoolAddress: WorkerRoutes.Worker.Pool.Address.path,
  WorkerPoolRadius: WorkerRoutes.Worker.Pool.Radius.path,
  WorkerPoolPersonalInformation:
    WorkerRoutes.Worker.Pool.PersonalInformation.path,
  WorkerPoolDocumentDetails: WorkerRoutes.Worker.Pool.Documents.type.getPath,
  WorkerPoolDocuments: WorkerRoutes.Worker.Pool.Documents.path,
  WorkerProfile: WorkerRoutes.Worker.Profile.path,
  WorkerProfileDetails: WorkerRoutes.Worker.Profile.Details.path,
  WorkerProfileDetailsProfessionalSituation:
    WorkerRoutes.Worker.Profile.Details.ProfessionalSituation.path,
  WorkerProfileDetailsDeleteMyAccount:
    WorkerRoutes.Worker.Profile.Details.DeleteMyAccount.path,
  WorkerProfileDetailsAccountDeleted:
    WorkerRoutes.Worker.Profile.Details.AccountDeleted.path,
  WorkerProfileDetailsEmail: WorkerRoutes.Worker.Profile.Details.Email.path,
  WorkerProfileDetailsHomeAddress:
    WorkerRoutes.Worker.Profile.Details.HomeAddress.path,
  WorkerProfileDetailsPassword:
    WorkerRoutes.Worker.Profile.Details.Password.path,
  WorkerProfileDetailsPersonalInformation:
    WorkerRoutes.Worker.Profile.Details.PersonalInformation.path,
  WorkerProfileDetailsPhoneNumber:
    WorkerRoutes.Worker.Profile.Details.PhoneNumber.path,
  WorkerProfileDetailsProfilePicture:
    WorkerRoutes.Worker.Profile.Details.ProfilePicture.path,
  WorkerProfileCancellationPolicy:
    WorkerRoutes.Worker.Profile.CancellationPolicy.path,
  WorkerProfileDocuments: WorkerRoutes.Worker.Profile.Documents.path,
  WorkerProfileDocumentDetails:
    WorkerRoutes.Worker.Profile.Documents.type.getPath,
  WorkerProfileInstitutions: WorkerRoutes.Worker.Profile.Institutions.path,
  WorkerProfileInstitutionsDetails:
    WorkerRoutes.Worker.Profile.Institutions.Detail.path,
  WorkerProfileInstitutionsDetailsWithId:
    WorkerRoutes.Worker.Profile.Institutions.Detail.idInstitution.getPath,
  WorkerProfileInstitutionDepartments:
    WorkerRoutes.Worker.Profile.Institutions.Detail.departments.idInstitution
      .getPath,
  WorkerProfileInstitutionsSearch:
    WorkerRoutes.Worker.Profile.Institutions.Search.path,
  WorkerProfileInstitutionsSearchByCode:
    WorkerRoutes.Worker.Profile.Institutions.SearchByCode.path,
  WorkerProfileInstitutionsSearchByCodeList:
    WorkerRoutes.Worker.Profile.Institutions.SearchByCode.code.getPath,
  WorkerProfileInstitutionPresentation:
    WorkerRoutes.Worker.Profile.Institutions.idInstitution.Presentation.getPath,
  WorkerProfileInstitutionRestrictedByPricingPlan:
    WorkerRoutes.Worker.Profile.Institutions.idInstitution
      .RestrictedByPricingPlan.getPath,
  WorkerProfileInstitutionJoinOptions:
    WorkerRoutes.Worker.Profile.Institutions.JoinOptions.path,
  WorkerProfileJobs: WorkerRoutes.Worker.Profile.Jobs.path,
  WorkerProfileJobsAddJob: WorkerRoutes.Worker.Profile.Jobs.AddJob.path,
  WorkerProfileJobsAddSpecialties:
    WorkerRoutes.Worker.Profile.Jobs.AddSpecialties.path,
  WorkerProfileJobsJobDetails: WorkerRoutes.Worker.Profile.Jobs.JobDetails.path,
  WorkerProfileAvailabilities: WorkerRoutes.Worker.Profile.Availabilities.path,
  WorkerProfileAvailabilitiesAdd:
    WorkerRoutes.Worker.Profile.Availabilities.Add.path,
  WorkerProfileAvailabilitiesShiftDetails:
    WorkerRoutes.Worker.Profile.Availabilities.Shift.idMission.getPath,
  WorkerProfileAvailabilitiesShiftsDetails:
    WorkerRoutes.Worker.Profile.Availabilities.Shifts.date.getPath,
  WorkerProfileNotifications: WorkerRoutes.Worker.Profile.Notifications.path,
  WorkerProfileNotificationsByTemplate:
    WorkerRoutes.Worker.Profile.Notifications.ByTemplate.path,
  WorkerProfileCommunity: WorkerRoutes.Worker.Profile.Community.path,
  WorkerProfileCGU: WorkerRoutes.Worker.Profile.Cgu.path,
  WorkerProfilePrivacyPolicy: WorkerRoutes.Worker.Profile.PrivacyPolicy.path,
  WorkerProfilePool: WorkerRoutes.Worker.Profile.Pool.path,
  WorkerProfilePoolCancellation:
    WorkerRoutes.Worker.Profile.Pool.Cancellation.path,
  WorkerProfilePoolCancellationTracking:
    WorkerRoutes.Worker.Profile.Pool.Cancellation.CancellationTracking.path,
  WorkerProfilePoolPresentation:
    WorkerRoutes.Worker.Profile.Pool.Presentation.path,
  WorkerProfilePoolVerifiedSpecialties:
    WorkerRoutes.Worker.Profile.Pool.VerifiedSpecialties.path,
  WorkerProfilePoolWhatsApp: WorkerRoutes.Worker.Profile.Pool.WhatsApp.path,
  WorkerProfilePoolWorkArea: WorkerRoutes.Worker.Profile.Pool.WorkArea.path,
  WorkerProfileFeedback: WorkerRoutes.Worker.Profile.Feedback.path,
  WorkerJobOffers: WorkerRoutes.Worker.JobOffers.path,
  WorkerInstitutionJobOffers: WorkerRoutes.Worker.JobOffers.Institution.path,
  WorkerSchedule: WorkerRoutes.Worker.Schedule.path,
  WorkerScheduleNetworkDetails:
    WorkerRoutes.Worker.Schedule.Details.id.Network.getPath,
  WorkerScheduleAppliedShiftDetails:
    WorkerRoutes.Worker.Schedule.Details.id.Applied.getPath,
  WorkerScheduleNetworkDetailsApply:
    WorkerRoutes.Worker.Schedule.Details.id.Network.Apply.getPath,
  WorkerScheduleNetworkDetailsDealing:
    WorkerRoutes.Worker.Schedule.Details.id.Network.Dealing.getPath,
  WorkerSchedulePoolDetails:
    WorkerRoutes.Worker.Schedule.Details.id.Pool.getPath,
  WorkerSchedulePoolDetailsApply:
    WorkerRoutes.Worker.Schedule.Details.id.Pool.Apply.getPath,
  WorkerScheduleShiftDetails:
    WorkerRoutes.Worker.Schedule.Details.id.Shift.getPath,
  WorkerScheduleShiftsDetailsCancel:
    WorkerRoutes.Worker.Schedule.Details.id.Shift.Cancel.getPath,
  WorkerScheduleShiftsDetailsContact:
    WorkerRoutes.Worker.Schedule.Details.id.Shift.Contact.getPath,
  WorkerScheduleShiftHistory: WorkerRoutes.Worker.Schedule.ShiftHistory.path,
  WorkerShifts: WorkerRoutes.Worker.Shifts.path,
  WorkerShiftsDetails: WorkerRoutes.Worker.Shifts.Details.idMission.getPath,
  WorkerAppliedShiftDetails:
    WorkerRoutes.Worker.Shifts.Details.idMission.Applied.getPath,
  WorkerShiftsDetailsCancel:
    WorkerRoutes.Worker.Shifts.Details.idMission.Cancel.getPath,
  WorkerShiftsDetailsContact:
    WorkerRoutes.Worker.Shifts.Details.idMission.Contact.getPath,
  WorkerOffers: WorkerRoutes.Worker.Offers.path,
  WorkerOffersNetworkDetails:
    WorkerRoutes.Worker.Offers.Details.id.Network.getPath,
  WorkerOffersNetworkDetailsApply:
    WorkerRoutes.Worker.Offers.Details.id.Network.Apply.getPath,
  WorkerOffersNetworkDetailsDealing:
    WorkerRoutes.Worker.Offers.Details.id.Network.Dealing.getPath,
  WorkerOffersPoolDetails: WorkerRoutes.Worker.Offers.Details.id.Pool.getPath,
  WorkerOffersPoolDetailsApply:
    WorkerRoutes.Worker.Offers.Details.id.Pool.Apply.getPath,
  WorkerNetworkApplicationWorkingInstitutions:
    WorkerRoutes.Worker.NetworkApplications.idNetworkApplication
      .WorkingInstitutions.getPath,
  WorkerNetworkApplicationEmploymentStatus:
    WorkerRoutes.Worker.NetworkApplications.idNetworkApplication
      .EmploymentStatus.getPath,
  WorkerNetworkApplicationEmploymentStatusIncompatibleWithPricingPlan:
    WorkerRoutes.Worker.NetworkApplications.idNetworkApplication
      .EmploymentStatusIncompatibleWithPricingPlan.getPath,
  WorkerNetworkApplicationJobs:
    WorkerRoutes.Worker.NetworkApplications.idNetworkApplication.Jobs.getPath,
  WorkerNetworkApplicationSpecialties:
    WorkerRoutes.Worker.NetworkApplications.idNetworkApplication.Specialties
      .getPath,
  WorkerNetworkApplicationAssignment:
    WorkerRoutes.Worker.NetworkApplications.idNetworkApplication.Assignment
      .getPath,
  WorkerNetworkApplicationRegistrationNumber:
    WorkerRoutes.Worker.NetworkApplications.idNetworkApplication
      .RegistrationNumber.getPath,
  WorkerNetworkApplicationCharter:
    WorkerRoutes.Worker.NetworkApplications.idNetworkApplication.Charter
      .getPath,
  WorkerNetworkApplicationPersonalInformation:
    WorkerRoutes.Worker.NetworkApplications.idNetworkApplication
      .PersonalInformation.getPath,
  WorkerNetworkApplicationDocuments:
    WorkerRoutes.Worker.NetworkApplications.idNetworkApplication.Documents
      .getPath,
  WorkerNetworkApplicationDocumentDetails:
    WorkerRoutes.Worker.NetworkApplications.idNetworkApplication.Documents.type
      .getPath,
  WorkerNetworkApplicationNotifications:
    WorkerRoutes.Worker.NetworkApplications.idNetworkApplication.Notifications
      .getPath,
  WorkerNetworkApplicationSummary:
    WorkerRoutes.Worker.NetworkApplications.idNetworkApplication.Summary
      .getPath,
  WorkerNetworkApplicationCompleted:
    WorkerRoutes.Worker.NetworkApplications.idNetworkApplication.Completed
      .getPath,
  WorkerNetworkApplicationMissingDocuments:
    WorkerRoutes.Worker.NetworkApplications.idNetworkApplication
      .MissingDocuments.getPath,
}
